import { getData, postData } from '@/assets/js/api.js'

// 添加节律
export const Create = (params, fn) => {
  const methods = '/api/Rhythm/CreateNew'
  postData(methods, params, 1, fn)
}

// 修改节律
export const Edit = (params, fn) => {
  const methods = '/api/Rhythm/EditNew'
  postData(methods, params, 1, fn)
}

// 查询用户设置的节律详情
export const FindRhythm = (params, fn) => {
  const methods = '/api/Rhythm/FindNew'
  getData(methods, params, 1, fn)
}

// 删除节律
export const DeleteRhythm = (params, fn) => {
  const methods = '/api/Rhythm/Delete'
  getData(methods, params, 1, fn)
}

// 删除节律
export const DeleteGroup = (params, fn) => {
  const methods = '/api/IFttt/BatchDelete'
  getData(methods, params, 1, fn)
}

// 查询恒照度设备列表(简约信息+含设备是否被其他恒照度规则占用)
export const ChooseActionDeviceListRhythm = (params, fn) => {
  const methods = '/api/Rhythm/ChooseActionDeviceList'
  return getData(methods, params, 1, fn)
}

// 开启IFTTT
export const OpenRhythm = (params, fn) => {
  const methods = '/api/Rhythm/Open'
  getData(methods, params, 1, fn)
}

// 关闭IFTTT
export const CloseRhythm = (params, fn) => {
  const methods = '/api/Rhythm/Close'
  getData(methods, params, 1, fn)
}
